import { render, staticRenderFns } from "./TicketReplies.vue?vue&type=template&id=b876db38&"
import script from "./TicketReplies.vue?vue&type=script&lang=ts&"
export * from "./TicketReplies.vue?vue&type=script&lang=ts&"
import style0 from "./TicketReplies.vue?vue&type=style&index=0&id=b876db38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports